import React, { useEffect, useState } from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import {
  Typography,
  DatePicker,
  Table,
  TreeSelect,
  Badge,
  Spin,
  Tooltip,
} from "antd";
import { errorHandle, openNotificationWithIcon } from "../../Function";
import moment from "moment";
import { useSelector } from "react-redux";
import { ListBoPhanApi } from "../../../api/getListTeam";
import { GetOTSpecialApi } from "../../../api/getOvertime";
import { DownloadOTNS_DBApi } from "../../../api/getInfoData";

const { Link } = Typography;

export const OvertimeSpecial = () => {
  const [data, setData] = useState([]);
  const [lsTeam, setLsTeam] = useState([]);
  const [loading, setLoading] = useState(false);
  const [treeData, setTreeData] = useState([]);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(
    moment(new Date())
  );
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsAllTeam, setLsAllTeam] = useState([]);
  const [loading_page, setLoading_page] = useState(false);

  const mapDataLichOT = (data) => {
    let results = [];
    for (let i of data) {
      if (i.data.length === 0) {
        continue;
      }
      let obj = {};
      obj = i;
      obj.nhanvien = i.msnv + "-" + i.username;
      results.push(obj);
    }
    return results;
  };

  const columns_view = [
    {
      title: "Nhân Viên",
      dataIndex: "nhanvien",
      key: "nhanvien",
      className: "highlight",
      filterKey: "nhanvien",
      type: "text",
      align: "center",
      width: 70,
      canSearch: true,
      // fixed:'left'
    },
    {
      title: (
        <div>
          Thời Gian Thực Tế
          <br />
          Chưa Nhân Tỉ Lệ
        </div>
      ),
      dataIndex: "time_actual",
      key: "time_actual",
      filterKey: "time_actual",
      align: "center",
      type: "text",
      canSearch: true,
      children: [
        {
          title: "Sau 17h (100%)",
          dataIndex: "tongCong17_22",
          key: "tongCong17_22",
          filterKey: "tongCong17_22",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 50,
        },
        {
          title: "Sau 22h (100%)",
          dataIndex: "tongCong22_24",
          key: "tongCong22_24",
          filterKey: "tongCong22_24",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 50,
        },
        {
          title: (
            <Tooltip title="Phần công sau 6h sẽ tính vào cột [Sau 17h (100%)]">
              <span>0h00 ~ 7h (100%)</span>
            </Tooltip>
          ),
          dataIndex: "tongCong00_06",
          key: "tongCong00_06",
          filterKey: "tongCong00_06",
          className: "hoverBlur cursor-pointer text-decor",
          align: "center",
          type: "text",
          canSearch: true,
          width: 50,
        },
        {
          title: "Lễ tết (100%)",
          dataIndex: "tongCongLeTet",
          key: "tongCongLeTet",
          filterKey: "tongCongLeTet",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 50,
        },
        {
          title: (
            <Tooltip title="Sau 17h (100%) + Sau 22h (100%) + 0h00 ~ 6h (100%) + Lễ tết (100%)">
              <span>Tổng</span>
            </Tooltip>
          ),
          dataIndex: "tongCongChuaNhanTiLe",
          key: "tongCongChuaNhanTiLe",
          filterKey: "tongCongChuaNhanTiLe",
          className: "hoverBlur cursor-pointer color-red text-decor",
          align: "center",
          type: "text",
          canSearch: true,
          width: 50,
        },
        {
          title: (
            <Tooltip title="Sau 17h (100%) + sau 22h (100%) + 0h00 ~ 6h (100%)">
              <span style={{}}>100%</span>
            </Tooltip>
          ),
          dataIndex: "tongCongOT_100",
          key: "tongCongOT_100",
          filterKey: "tongCongOT_100",
          className: "hoverBlur cursor-pointer text-decor",
          align: "center",
          type: "text",
          canSearch: true,
          width: 50,
        },
      ],
    },
    {
      title: "Hiện Tại",
      dataIndex: "ot_normal",
      key: "ot_normal",
      filterKey: "ot_normal",
      align: "center",
      type: "text",
      canSearch: true,
      children: [
        {
          title: "Sau 17H (150%)",
          dataIndex: "tongCongOT_150",
          key: "tongCongOT_150",
          filterKey: "tongCongOT_150",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
        {
          title: "Sau 22H (200%)",
          dataIndex: "tongCongOT_200",
          key: "tongCongOT_200",
          filterKey: "tongCongOT_200",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
        {
          title: (
            <Tooltip title="Phần công sau 6h sẽ tính vào cột [Sau 17H (150%)]">
              <span>0h00 ~ 7h (200%)</span>
            </Tooltip>
          ),
          dataIndex: "tongCongOT_200_sau_00",
          key: "tongCongOT_200_sau_00",
          filterKey: "tongCongOT_200_sau_00",
          className: "hoverBlur cursor-pointer text-decor",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
        {
          title: "Lễ tết (300%)",
          dataIndex: "tongCongLeTet_300",
          key: "tongCongLeTet_300",
          filterKey: "tongCongLeTet_300",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
        {
          title: (
            <Tooltip title="Sau 17H (150%) + Sau 22H (200%) + 0h00 ~ 6h (200%) + Lễ tết (300%)">
              <span>Tổng Bình Thường</span>
            </Tooltip>
          ),
          dataIndex: "tongCongOT_thuong",
          key: "tongCongOT_thuong",
          filterKey: "tongCongOT_thuong",
          className: "hoverBlur cursor-pointer color-red text-decor",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
      ],
    },

    // Phần OT Đặc biệt
    {
      title: "Đặc Biệt",
      dataIndex: "ot_special",
      key: "ot_special",
      filterKey: "ot_special",
      align: "center",
      type: "text",
      canSearch: true,
      children: [
        {
          title: "Sau 17H (240%)",
          dataIndex: "tongCongOT_240",
          key: "tongCongOT_240",
          filterKey: "tongCongOT_240",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
        {
          title: "Sau 22H (300%)",
          dataIndex: "tongCongOT_300",
          key: "tongCongOT_300",
          filterKey: "tongCongOT_300",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
        {
          title: (
            <Tooltip title="Phần công sau 6h sẽ tính vào cột [Sau 17H (240%)]">
              <span>0h00 ~ 7h (300%)</span>
            </Tooltip>
          ),
          dataIndex: "tongCongOT_300_sau_00",
          key: "tongCongOT_300_sau_00",
          filterKey: "tongCongOT_300_sau_00",
          className: "hoverBlur cursor-pointer text-decor",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
        {
          title: "Lễ tết (350%)",
          dataIndex: "tongCongLeTet_350",
          key: "tongCongLeTet_350",
          filterKey: "tongCongLeTet_350",
          className: "hoverBlur",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
        {
          title: (
            <Tooltip title="Sau 17H (240%) + Sau 22H (300%) + 0h00 ~ 6h (300%) + Lễ tết (350%)">
              <span>Tổng Đặc Biệt</span>
            </Tooltip>
          ),
          dataIndex: "tongCongOT_ĐB",
          key: "tongCongOT_ĐB",
          filterKey: "tongCongOT_ĐB",
          className: "hoverBlur cursor-pointer color-red text-decor",
          align: "center",
          type: "text",
          canSearch: true,
          width: 40,
        },
      ],
    },
  ];

  const fetchData = (params = {}) => {
    setLoading(true);
    const date_select = params.date || currentSelectedDate;
    const firstDayOfMonth = new Date(
      new Date(date_select).getFullYear(),
      new Date(date_select).getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      new Date(date_select).getFullYear(),
      new Date(date_select).getMonth() + 1,
      0
    );
    GetOTSpecialApi({
      idTeam: params.idTeam,
      tuNgay: moment(firstDayOfMonth).format("YYYYMMDD"),
      denNgay: moment(lastDayOfMonth).format("YYYYMMDD"),
    })
      .then((r) => {
        const newData = mapDataLichOT(r.data);
        setData(newData);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      const arrTeam = userInfo.team_permissions
        .filter((item) => item.phanquyen__ten_pq === "overtime_ns")
        .map((item, index) => {
          const idBoPhanForTeam = res.data.filter((itemBP) =>
            itemBP.team.some((itemT) => itemT.id == item.team)
          );
          if (idBoPhanForTeam.length != 0) {
            return {
              idTeam: item.team,
              team: item.team__tenTeam,
              idBoPhan: idBoPhanForTeam[0].id,
            };
          }
          return false;
        })
        .filter((item) => item != false);
      const uniqueArrTeam = [
        ...new Map(arrTeam.map((item) => [item["idTeam"], item])).values(),
      ];
      uniqueArrTeam.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });
      const arrIdTeam = uniqueArrTeam.map((item) => item.idTeam);
      const arrBoPhan = res.data.filter(({ team }) =>
        team.some((item) => arrIdTeam.includes(item.id))
      );
      if (arrBoPhan.length > 0) {
        setCurrentBoPhan([arrBoPhan[0].id]);
      }
      setLsBoPhan(arrBoPhan);

      setLsAllTeam(uniqueArrTeam);
      if (currentTeam.length === 0) {
        setCurrentTeam([
          arrIdTeam.filter((x) =>
            arrBoPhan[0].team.map((item) => item.id).includes(x)
          )[0],
        ]); // 200423 lấy element đầu tiên đặt trong list
      }
      setLsTeam(
        uniqueArrTeam.filter((x) =>
          arrBoPhan[0].team.map((item) => item.id).includes(x.idTeam)
        )
      );
    });
  };

  useEffect(() => {
    if (currentTeam.length > 0) {
      fetchData({
        idTeam: JSON.stringify(currentTeam),
        thoiGian: moment(currentSelectedDate),
      });
    }
    if (currentTeam.length === 0) {
      setData([{}]);
    }
  }, [currentSelectedDate, currentTeam]);

  useEffect(() => {
    if (
      userInfo &&
      userInfo.team_permissions &&
      userInfo.team_permissions.length > 0
    ) {
      fetchListTeam();
    }
  }, [userInfo]);

  const updateData = () => {
    fetchData({
      idTeam: JSON.stringify(currentTeam),
      thoiGian: moment(currentSelectedDate),
    });
  };

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = lsAllTeam.filter((x) => value.includes(x.idBoPhan));
      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]); // 200423
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  const onChangeTeam = (value) => {
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => setCurrentTeam([])}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => setCurrentTeam(lsTeam.map((item) => item.idTeam))}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return {
        title: (
          <span
            onClick={() => {
              return loading && false;
            }}
          >
            {item.team}
          </span>
        ),
        value: item.idTeam,
        key: item.idTeam,
      };
    });
    setTreeData(treeDataTemp);
  }, [lsTeam]);

  const onChangeMonth = (date) => {
    setCurrentSelectedDate(date);
  };

  const onQuickChangeMonth = (type) => {
    let monthChange;
    if (type === "previous") {
      monthChange = moment(currentSelectedDate).subtract(1, "month");
    } else {
      monthChange = moment(currentSelectedDate).add(1, "month");
    }
    setCurrentSelectedDate(monthChange);
  };

  function disabledMonth(current) {
    // Can not select days after today and today
    const currentDate = new Date();
    return (
      current &&
      current >
        moment(
          new Date(currentDate.getFullYear(), currentDate.getMonth()),
          0
        ).endOf("day")
    );
  }

  const fileDownload_TongHopOTNS = () => {
    const fnFileDownload = require("js-file-download");
    const filename =
      "BangTangCaDacBiet_" +
      moment(new Date()).format("YYMMDD_HHMMSS") +
      ".xlsx";
    setLoading_page(true);

    const date_select = moment(currentSelectedDate);
    const firstDayOfMonth = new Date(
      new Date(date_select).getFullYear(),
      new Date(date_select).getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      new Date(date_select).getFullYear(),
      new Date(date_select).getMonth() + 1,
      0
    );

    DownloadOTNS_DBApi({
      idTeam: JSON.stringify(currentTeam),
      tuNgay: moment(firstDayOfMonth).format("YYYYMMDD"),
      denNgay: moment(lastDayOfMonth).format("YYYYMMDD"),
    })
      .then((res) => {
        fnFileDownload(res.data, filename);
        setLoading_page(false);
        openNotificationWithIcon("success", "Tải file thành công", "");
      })
      .catch((error) => {
        console.log(error);
        openNotificationWithIcon(
          "error",
          "Lỗi",
          "Chưa có danh sách tăng ca hoặc chưa phê duyệt"
        );
        // errorHandle(error);
        setLoading_page(false);
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Tổng hợp tăng ca đặc biệt</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link href="#">Nhân sự</Link>
                </li>
                <li className="breadcrumb-item active">Tổng hợp tăng ca</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className={
            "col-12 mb-2 d-sm-flex align-items-center justify-content-between"
          }
        >
          <div className={"col"}>
            <Button
              type="primary"
              className={"m-2 styleNtn_1"}
              onClick={() => onQuickChangeMonth("previous")}
              title="Tuần trước"
            >
              <i className={"fa fa-arrow-left"}></i>
            </Button>
            {new Date(currentSelectedDate).getTime() <
              new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1
              ).getTime() && (
              <Button
                type="primary"
                className={"m-2 styleNtn_1"}
                onClick={() => onQuickChangeMonth("next")}
                title="Tháng sau"
              >
                <i className={"fa fa-arrow-right"}></i>
              </Button>
            )}
            <DatePicker
              disabledDate={disabledMonth}
              style={{ borderRadius: 10 }}
              className={"m-2"}
              disabled={loading}
              onChange={onChangeMonth}
              picker={"month"}
              value={currentSelectedDate}
              format={"MM/YYYY"}
              allowClear={false}
            />

            <div className="styleBadge">
              <Badge.Ribbon
                text="Bộ phận"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_BoPhan} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                <TreeSelect {...tPropsConfig} />
              </Badge.Ribbon>
            </div>
          </div>
          <div>
            <Button
              type={"danger"}
              className={"m-2 btnGreen"}
              style={{ marginRight: 5 }}
              onClick={fileDownload_TongHopOTNS}
            >
              Tải xuống
            </Button>
          </div>
        </div>
      </div>
      <Spin spinning={loading_page}>
        <div className="row">
          <Table
            dataSource={data}
            columns={columns_view}
            loading={loading}
            bordered={true}
            // scroll={ data.length > 0 && {x:1920,y:500}}
            scroll={{ y: 500 }}
            size={"small"}
            rowKey="id"
            className={"custom-table-hover style-6"}
            pagination={false}
          />
        </div>
      </Spin>
    </>
  );
};
